// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var MathUtils = require("../MathUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var GraphqlHelpers = require("../GraphqlHelpers.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_City = require("./CommonTypes_City.bs.js");
var CommonTypes_ShiftType = require("./CommonTypes_ShiftType.bs.js");

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "STANDARD_HOLIDAY") {
      return /* StandardHoliday */3;
    } else if (param === "LAST_MINUTE_HOLIDAY") {
      return /* LastMinuteHoliday */4;
    } else if (param === "EARLY_BIRD_HOLIDAY") {
      return /* EarlyBirdHoliday */2;
    } else if (param === "LAST_MINUTE") {
      return /* LastMinute */1;
    } else {
      return /* Standard */0;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

var Category = {
  parseApiResponse: parseApiResponse
};

var Raw = {};

function parse(value) {
  var value$1 = value.averageRate;
  var value$2 = value.cityId;
  var value$3 = value.endDatetime;
  var value$4 = value.minimumRate;
  var tmp;
  if (value$4 == null) {
    tmp = undefined;
  } else {
    var value$5 = value$4.minRate;
    var value$6 = value$4.category;
    var tmp$1;
    if (value$6 == null) {
      tmp$1 = undefined;
    } else {
      var tmp$2;
      switch (value$6) {
        case "EARLY_BIRD_HOLIDAY" :
            tmp$2 = "EARLY_BIRD_HOLIDAY";
            break;
        case "LAST_MINUTE" :
            tmp$2 = "LAST_MINUTE";
            break;
        case "LAST_MINUTE_HOLIDAY" :
            tmp$2 = "LAST_MINUTE_HOLIDAY";
            break;
        case "STANDARD" :
            tmp$2 = "STANDARD";
            break;
        case "STANDARD_HOLIDAY" :
            tmp$2 = "STANDARD_HOLIDAY";
            break;
        default:
          tmp$2 = {
            NAME: "FutureAddedValue",
            VAL: value$6
          };
      }
      tmp$1 = tmp$2;
    }
    tmp = {
      minRate: !(value$5 == null) ? value$5 : undefined,
      category: tmp$1
    };
  }
  var value$7 = value.shiftTypeId;
  var value$8 = value.startDatetime;
  return {
          averageRate: !(value$1 == null) ? value$1 : undefined,
          cityId: !(value$2 == null) ? value$2 : undefined,
          endDatetime: !(value$3 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$3)) : undefined,
          minimumRate: tmp,
          shiftTypeId: !(value$7 == null) ? Caml_option.some(Curry._1(CommonTypes_ShiftType.Id.GraphQL_API.parse, value$7)) : undefined,
          startDatetime: !(value$8 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$8)) : undefined
        };
}

function serialize(value) {
  var value$1 = value.startDatetime;
  var startDatetime = value$1 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$1)) : null;
  var value$2 = value.shiftTypeId;
  var shiftTypeId = value$2 !== undefined ? Curry._1(CommonTypes_ShiftType.Id.GraphQL_API.serialize, Caml_option.valFromOption(value$2)) : null;
  var value$3 = value.minimumRate;
  var minimumRate;
  if (value$3 !== undefined) {
    var value$4 = value$3.category;
    var category = value$4 !== undefined ? (
        typeof value$4 === "string" ? (
            value$4 === "STANDARD_HOLIDAY" ? "STANDARD_HOLIDAY" : (
                value$4 === "LAST_MINUTE_HOLIDAY" ? "LAST_MINUTE_HOLIDAY" : (
                    value$4 === "EARLY_BIRD_HOLIDAY" ? "EARLY_BIRD_HOLIDAY" : (
                        value$4 === "LAST_MINUTE" ? "LAST_MINUTE" : "STANDARD"
                      )
                  )
              )
          ) : value$4.VAL
      ) : null;
    var value$5 = value$3.minRate;
    var minRate = value$5 !== undefined ? value$5 : null;
    minimumRate = {
      minRate: minRate,
      category: category
    };
  } else {
    minimumRate = null;
  }
  var value$6 = value.endDatetime;
  var endDatetime = value$6 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$6)) : null;
  var value$7 = value.cityId;
  var cityId = value$7 !== undefined ? value$7 : null;
  var value$8 = value.averageRate;
  var averageRate = value$8 !== undefined ? value$8 : null;
  return {
          averageRate: averageRate,
          cityId: cityId,
          endDatetime: endDatetime,
          minimumRate: minimumRate,
          shiftTypeId: shiftTypeId,
          startDatetime: startDatetime
        };
}

function verifyArgsAndParse(_CommonTypes_Shift_RateStats, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var cityId = param.cityId;
  var averageRate = param.averageRate;
  if (cityId === undefined) {
    return ;
  }
  var endDatetime = param.endDatetime;
  if (endDatetime === undefined) {
    return ;
  }
  var match = param.minimumRate;
  if (match === undefined) {
    return ;
  }
  var minimumRateCents = match.minRate;
  if (minimumRateCents === undefined) {
    return ;
  }
  var category = match.category;
  if (category === undefined) {
    return ;
  }
  var shiftTypeId = param.shiftTypeId;
  if (shiftTypeId === undefined) {
    return ;
  }
  var startDatetime = param.startDatetime;
  if (startDatetime === undefined) {
    return ;
  }
  var startDatetime$1 = Caml_option.valFromOption(startDatetime);
  var shiftTypeId$1 = Caml_option.valFromOption(shiftTypeId);
  var endDatetime$1 = Caml_option.valFromOption(endDatetime);
  return Relude_Option.map((function (cityId) {
                return {
                        averageRateCents: Relude_Option.getOrElse(minimumRateCents, averageRate),
                        category: parseApiResponse(category),
                        cityId: cityId,
                        endDatetime: endDatetime$1,
                        minimumRateCents: minimumRateCents,
                        shiftTypeId: shiftTypeId$1,
                        startDatetime: startDatetime$1
                      };
              }), Curry._1(CommonTypes_City.Id.fromInt, cityId));
}

var maxMinimumRateOfArray = Curry._1(Relude_Array.maxBy, Curry._1(Relude_Int.compareWithConversion, (function (param) {
            return param.minimumRateCents;
          })));

var maxAverageRateOfArray = Curry._1(Relude_Array.maxBy, Curry._1(Relude_Int.compareWithConversion, (function (param) {
            return param.minimumRateCents;
          })));

function toMinimumCategoryBasedWarningMessage(param) {
  return Relude_Globals.$great$great(maxMinimumRateOfArray, (function (param) {
                return Relude_Option.map((function (param) {
                              var match = param.category;
                              if (typeof match === "number") {
                                if (match !== 1) {
                                  if (match !== 0) {
                                    return "Data shows that the increased rate for high quality Professionals to fill this shift type is " + (MathUtils.formatCentsToMoney(param.minimumRateCents) + " right now");
                                  } else {
                                    return "Data shows that a minimum rate for high quality Professionals to fill this shift type is " + MathUtils.formatCentsToMoney(param.minimumRateCents);
                                  }
                                } else {
                                  return "Last Minute Shift: Data shows that a minimum rate for high quality Professionals to fill this shift type is " + MathUtils.formatCentsToMoney(param.minimumRateCents);
                                }
                              } else {
                                return "Our data shows that this shift rate is too low and won't be able to be filled";
                              }
                            }), param);
              }), param);
}

var query = "fragment CommonTypes_Shift_RateStats on ShiftRateStatsRecord   {\naverageRate  \ncityId  \nendDatetime  \nminimumRate  {\nminRate: value  \ncategory  \n}\n\nshiftTypeId  \nstartDatetime  \n}\n";

exports.Category = Category;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.maxMinimumRateOfArray = maxMinimumRateOfArray;
exports.maxAverageRateOfArray = maxAverageRateOfArray;
exports.toMinimumCategoryBasedWarningMessage = toMinimumCategoryBasedWarningMessage;
/* maxMinimumRateOfArray Not a pure module */
